import { useEffect } from 'react';
import { Navigate, useLocation, type Location } from 'react-router-dom';
import { AuthLayout } from '@/components/layout/auth-layout';
import { LoginForm } from '@/components/auth/login-form';
import { useAuthStore } from '@/stores/auth-store';
import { analytics } from '@/config/firebase';
import { logEvent } from 'firebase/analytics';

export function LoginPage() {
  useEffect(() => {
    document.title = 'Ulgebra | Login';
    if (analytics) logEvent(analytics, 'page_view', { page_title: document.title });
  }, []);
  const user = useAuthStore((s) => s.user);
  const location = useLocation();

  // Redirect to the page the user came from after login.
  // Priority: 1) nextpage query param (survives full-page reloads like Google OAuth)
  //           2) Router state (in-app navigation)
  //           3) /send-sms as fallback
  const nextpage = new URLSearchParams(location.search).get('nextpage');
  const stateFrom = (location.state as { from?: { pathname: string } })?.from?.pathname;
  const from = nextpage || stateFrom || '/send-sms';

  if (user) {
    return <Navigate to={from} replace />;
  }

  return (
    <AuthLayout>
      <LoginForm />
    </AuthLayout>
  );
}
